<template>
<div id="app" class="app">
  <portal-target name="root" class="root"/>

  <transition name="slide-fade">
    <router-view/>
  </transition>

  <div v-if="dev" class="developer-banner">
    DEVELOPER MODE
  </div>
</div>
</template>
<script>
import devMode from '@/devMode.js'

import logScope from 'log-scope'
const log = logScope('App')

export default {
  name: 'App',
  data () {
    return {
      dev: devMode.devDatabase === true
    }
  },
  mounted () {
    this.ABTest()
  },
  methods: {
    ABTest () {
      // A/B test identifier code
      const query = this.$route.query ? { ...this.$route.query } : {}
      const ab = query.ab || localStorage.getItem('abTestCode')

      if (!ab) {
        log.warning('No A/B code')
        return
      }

      delete query.ab
      this.$router.replace({ query })

      log.debug('A/B code: ' + ab)

      // Store A/B code in local storage
      localStorage.setItem('abTestCode', ab)
      this.$store.commit('abTestCode', ab)
    }
  }
}
</script>
<style lang="less">
  @import '~style/vueElElement.less';

  body, html, #app {
    height: 100%;
    min-height: 1vh;
    margin: 0px;
  }

  .root {
    z-index: 100;
  }

  .slide-fade-enter-active {
    transition: all 0.5s ease-out;
  }

  .slide-fade-enter {
    transform: translateY(-20px);
  }

  .developer-banner {
    position: fixed;
    z-index: 10;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 20px;
    background-color: #E98C8D;
    border-top: 3px solid #ffffff;
    color: rgb(97, 41, 34);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
  }
</style>
